import React, {useEffect, useRef, useState} from 'react';
import './FindingTrail.scss';
import uniqid from 'uniqid';
import {useParams} from 'react-router-dom';
import {getAudits} from '../../../../services/findings';
import {Empty} from 'antd';
import {t} from 'react-switch-lang';
import FindingTrailComment from './components/FindingTrailAction/FindingTrailComment';
import Loader from '../../../../components/loader/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
const FindingTrail = () => {
  const [comments, setComments] = useState([]);
  const [dataLoaded, setDataIsLoaded] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const listId = uniqid();
  const params = useParams();

  const fetchData = () => {
    setHasMore(true);
    setPageNumber(0);
    getAudits(params.findingId, 0)
      .then((r) => {
        setDataIsLoaded(true);
        onFetchSuccess(r);
      })
      .catch((r) => {
        setDataIsLoaded(true);
      });
  };

  const onFetchSuccess = (r) => {
    if (r.data.length !== 0) {
      setComments(r.data);
      setPageNumber(1);
    } else {
      setComments(r.data);
      setHasMore(false);
    }
  };

  const fetchMoreData = () => {
    getAudits(params.findingId, pageNumber)
      .then((r) => onFetchMoreSuccess(r))
      .catch((r) => {});
  };

  const onFetchMoreSuccess = (r) => {
    if (r.data.length !== 0) {
      const newData = comments;
      r.data.map((item) => newData.push(item));
      setComments(newData);
      setPageNumber(pageNumber + 1);
    } else {
      setHasMore(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <div className="finding-trail-list" id={listId}>
      {comments?.length > 0 ? (
        <InfiniteScroll
          dataLength={comments.length}
          next={fetchMoreData}
          hasMore={hasMore}
          scrollableTarget={listId}
          scrollThreshold={0.5}
          loader={<Loader />}
        >
          {comments?.map((comment) => {
            return <FindingTrailComment comment={comment} />;
          })}
        </InfiniteScroll>
      ) : dataLoaded ? (
        <Empty
          description={t('common.noData')}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <div
          className={`w-100 bg-white`}
          style={{zIndex: '100000', height: '70px'}}
        >
          <div className="loader bg-white"></div>
        </div>
      )}
    </div>
  );
};

export default FindingTrail;
